import useStateStore from 'services/store';
import './selected-fabric.scss';

const SelectedFabric = () => {
    const {
        activeFabric,
        isApplyForAll,
        currentConfig,
        activeProductData,
        fabricApplied,
        setActiveFabrics,
        changeApplyForAll,
        changeShowSelectedFabric,
        changeFabricApplied,
        removeSelectedFabric,
        addNewProduct,
        isAddMoreShirt,
    } = useStateStore();

    const handleRemoveFabric = (
        e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
        fabricId: string
    ) => {
        e.stopPropagation();
        removeSelectedFabric(fabricId);
    };
    const handleChangeApplyFabric = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        !checked && changeFabricApplied('');
        changeApplyForAll(checked);
        if (checked) {
            // show form to select fabric
            if (Object.keys(activeProductData).length !== 1) {
                changeShowSelectedFabric(true);
            } else {
                changeFabricApplied(activeFabric);
            }
        }
    };

    return (
        <div className={`current-fabrics ${currentConfig ? 'right' : ''}`}>
            <div className="checkbox-container">
                {/* {isAddMoreShirt && (
                    <div className="fabric-apply">
                        <label htmlFor="apply-all">Apply For All Fabrics</label>
                        <input
                            onChange={(e) => handleChangeApplyFabric(e)}
                            type="checkbox"
                            id="apply-all"
                            className="checkbox"
                            checked={isApplyForAll}
                        />
                    </div>
                )} */}
            </div>
            <div className="fabrics-container">
                {Object.keys(activeProductData).map((fab, index) => {
                    const curProduct = activeProductData[fab];
                    return (
                        <div
                            onClick={() => setActiveFabrics(fab)}
                            key={fab}
                            className={`fab-container 
              ${isApplyForAll && fabricApplied !== fab ? 'disabled' : ''}
              ${activeFabric === fab ? 'active' : ''}`}
                        >
                            <span
                                onClick={(e) => handleRemoveFabric(e, fab)}
                                className={`remove-btn ${activeFabric === fab ? 'hide' : ''} `}
                            >
                                &#x2715;
                            </span>
                            <div className="number">{`fabric ${index + 1}`}</div>
                            <div className="img">
                                <img src={`${curProduct?.fabric?.img}`} alt="" />
                            </div>
                            <div className="name">{curProduct?.fabric?.name}</div>
                        </div>
                    );
                })}
                {Object.keys(activeProductData).length < 3 && isAddMoreShirt ? (
                    <span onClick={addNewProduct} className="add-more-fabric">
                        <img src="images/plus.svg" alt="" />
                    </span>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

export default SelectedFabric;
